import { Progress } from "@/shared/ui/Progress";

type ProgressWithPercentProps = {
  percent: number
  animated?: boolean
};

const ProgressWithPercent = ({ percent, animated = true }: ProgressWithPercentProps) => {
  const isProgressing = animated && percent > 0 && percent < 100;
  // Round to nearest integer to prevent layout shifts
  const roundedPercent = Math.round(percent);

  return (
    <div className="w-full flex justify-between items-center gap-[0.5rem]">
      <Progress value={percent} isProgressing={isProgressing} disableAnimation={!animated} />
      <span className="min-w-[2rem] text-xs text-right text-gray-500">
        {roundedPercent}
        %
      </span>
    </div>
  );
};

export default ProgressWithPercent;
